document.addEventListener('DOMContentLoaded', () => {

    // =============================================
    // 1. Custom Modal for Bundle warnings
    // =============================================
    const showBundleModal = (message, isConfirm, onConfirm) => {
        let modal = document.getElementById('saka-bundle-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'saka-bundle-modal';
            modal.style.cssText = `
                position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
                background: rgba(0,0,0,0.5); display: flex; align-items: center; 
                justify-content: center; z-index: 999999;
            `;
            
            const dialog = document.createElement('div');
            dialog.style.cssText = `
                background: #fff; padding: 14px 14px 8px 14px; border-radius: 8px; 
                max-width: 400px; width: 90%; text-align: center; box-shadow: 0 4px 10px rgba(0,0,0,0.2);
            `;
            
            const text = document.createElement('p');
            text.id = 'saka-bundle-modal-text';
            text.style.cssText = 'margin: 0 0 12px 0; font-size: 15px; color: #333; line-height: 1.4;';
            
            const btnContainer = document.createElement('div');
            btnContainer.style.cssText = 'display: flex; justify-content: center; gap: 10px;';
            
            const btnCancel = document.createElement('button');
            btnCancel.id = 'saka-bundle-modal-cancel';
            btnCancel.textContent = 'Cancel';
            btnCancel.style.cssText = `
                padding: 8px 18px; border: 1px solid #ccc; background: #fff; 
                border-radius: 4px; cursor: pointer; color: #333; font-weight: 500;
            `;
            
            const btnConfirm = document.createElement('button');
            btnConfirm.id = 'saka-bundle-modal-confirm';
            btnConfirm.style.cssText = `
                padding: 8px 18px; border: none; background: #000; color: #fff; 
                border-radius: 4px; cursor: pointer; font-weight: 500;
            `;
            
            btnContainer.appendChild(btnCancel);
            btnContainer.appendChild(btnConfirm);
            dialog.appendChild(text);
            dialog.appendChild(btnContainer);
            modal.appendChild(dialog);
            document.body.appendChild(modal);
            
            // Close modal events
            modal.addEventListener('click', (e) => {
                if (e.target === modal || e.target === btnCancel) {
                    modal.style.display = 'none';
                }
            });
        }
        
        // Update content and behavior based on type
        document.getElementById('saka-bundle-modal-text').innerText = message;
        
        const cancelBtn = document.getElementById('saka-bundle-modal-cancel');
        const confirmBtn = document.getElementById('saka-bundle-modal-confirm');
        
        if (isConfirm) {
            cancelBtn.style.display = 'block';
            confirmBtn.textContent = 'Yes, Remove';
            confirmBtn.onclick = () => {
                modal.style.display = 'none';
                if (onConfirm) onConfirm();
            };
        } else {
            cancelBtn.style.display = 'none';
            confirmBtn.textContent = 'OK';
            confirmBtn.onclick = () => {
                modal.style.display = 'none';
            };
        }
        
        modal.style.display = 'flex';
    };


    // =============================================
    // 2. Utility helpers
    // =============================================

    /** Get the Shopify line-item key from a cart row element */
    function getLineKey(el) {
        return el.dataset.line 
            || (el.querySelector('[data-line]') ? el.querySelector('[data-line]').dataset.line : null);
    }

    /** Push quantity updates to the Shopify cart and reload the page */
    function updateCartAndReload(updates, loadingEl) {
        if (Object.keys(updates).length === 0) return;

        if (loadingEl) {
            loadingEl.style.opacity = '0.5';
            loadingEl.style.pointerEvents = 'none';
        }

        fetch(window.routes?.cart_update_url || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
        })
        .then(r => r.json())
        .then(() => window.location.reload())
        .catch(err => {
            console.error('Saka Cart Error:', err);
            window.location.reload();
        });
    }


    // =============================================
    // 3. Remove-button intercept (capture phase)
    //    Blocks individual removal, offers to
    //    remove the entire Discovery Set instead.
    // =============================================
    document.body.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('.cart-remove, .previewCartItem-remove, [data-cart-remove]');
        if (!removeBtn) return;

        const itemRow = e.target.closest('[data-bundle-id]');
        if (!itemRow) return;                       // Not a bundle item – let native handler run

        const bundleId = itemRow.dataset.bundleId;
        if (!bundleId) return;

        // Always block individual removal for discovery-set items
        e.preventDefault();
        e.stopPropagation();

        showBundleModal(
            'This item is part of a Discovery Set. Removing it will remove the entire set. Continue?',
            true,
            () => {
                // Remove every line item that belongs to this bundle
                const bundleItems = document.querySelectorAll(`[data-bundle-id="${bundleId}"]:not(.saka-set-multiplier)`);
                let updates = {};
                bundleItems.forEach(el => {
                    const key = getLineKey(el);
                    if (key) updates[key] = 0;
                });

                const wrapper = document.querySelector('.previewCart-wrapper') || document.querySelector('.cart-container');
                updateCartAndReload(updates, wrapper);
            }
        );
    }, true); // capture phase


    // =============================================
    // 4. Set Multiplier — inject + handle
    // =============================================

    /**
     * Scans the cart DOM for bundle groups and injects a
     * "Discovery Set  ×N  [−] [+]" multiplier row after
     * the last item in each group.
     */
    function initBundleMultipliers() {
        // Clean up any previously injected elements
        document.querySelectorAll('.saka-set-multiplier').forEach(el => el.remove());
        document.querySelectorAll('.saka-bundle-wrapper').forEach(wrapper => {
            // Move children back out before removing wrapper
            while (wrapper.firstChild) {
                wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
            }
            wrapper.remove();
        });

        // Collect unique bundle IDs
        const bundleIds = new Set();
        document.querySelectorAll('[data-bundle-id]').forEach(el => {
            if (el.dataset.bundleId) bundleIds.add(el.dataset.bundleId);
        });

        bundleIds.forEach(bid => {
            const items = Array.from(
                document.querySelectorAll(`[data-bundle-id="${bid}"]`)
            );
            if (items.length === 0) return;

            // Mark items visually
            items.forEach((item, i) => {
                item.classList.add('saka-bundle-item');
                if (i === items.length - 1) item.classList.add('saka-bundle-item--last');
            });

            const lastItem  = items[items.length - 1];
            const firstItem = items[0];

            // Current per-item quantity = the set multiplier
            const qtyInput = firstItem.querySelector('input.quantity, input.cart-item-qty-input');
            const currentMultiplier = qtyInput ? parseInt(qtyInput.value || 1, 10) : 1;

            const hintText = currentMultiplier > 1
                ? currentMultiplier + ' × 4 items = ' + (currentMultiplier * 4) + ' total'
                : '4 items per set';

            // Create multiplier header
            const headerRow = document.createElement('div');
            headerRow.className = 'saka-set-multiplier saka-set-multiplier--top';
            headerRow.dataset.bundleId = bid;
            headerRow.innerHTML = `
                <div class="saka-set-multiplier__inner">
                    <div class="saka-set-multiplier__left">
                        <span class="saka-set-multiplier__badge">SET</span>
                        <span class="saka-set-multiplier__label">Discovery Set</span>
                    </div>
                    <div class="saka-set-multiplier__right">
                        <div class="saka-set-multiplier__controls">
                            <button class="saka-set-multiplier__btn saka-set-minus" type="button"
                                ${currentMultiplier <= 1 ? 'disabled' : ''} aria-label="Decrease set quantity">−</button>
                            <span class="saka-set-multiplier__value">${currentMultiplier}</span>
                            <button class="saka-set-multiplier__btn saka-set-plus" type="button"
                                aria-label="Increase set quantity">+</button>
                        </div>
                        <span class="saka-set-multiplier__hint">${hintText}</span>
                    </div>
                </div>
            `;

            // Create a wrapper div and move everything into it
            const wrapper = document.createElement('div');
            wrapper.className = 'saka-bundle-wrapper';

            // Insert wrapper where the first item is
            firstItem.parentNode.insertBefore(wrapper, firstItem);

            // Move header + all items into wrapper
            wrapper.appendChild(headerRow);
            items.forEach(item => wrapper.appendChild(item));
        });
    }


    /** Handle clicks on the set multiplier +/− buttons */
    document.body.addEventListener('click', (e) => {
        const btn = e.target.closest('.saka-set-multiplier__btn');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const row     = btn.closest('.saka-set-multiplier');
        const bid     = row.dataset.bundleId;
        const valEl   = row.querySelector('.saka-set-multiplier__value');
        const hintEl  = row.querySelector('.saka-set-multiplier__hint');
        let   current = parseInt(valEl.textContent, 10);

        if (btn.classList.contains('saka-set-minus')) {
            if (current <= 1) return;
            current--;
        } else {
            current++;
        }

        // Optimistic UI update — sync BOTH top and bottom multiplier rows
        const allRows = document.querySelectorAll(`.saka-set-multiplier[data-bundle-id="${bid}"]`);
        const hintText = current > 1
            ? current + ' \u00d7 4 items = ' + (current * 4) + ' total'
            : '4 items per set';
        allRows.forEach(r => {
            r.querySelector('.saka-set-multiplier__value').textContent = current;
            r.querySelector('.saka-set-minus').disabled = (current <= 1);
            r.querySelector('.saka-set-multiplier__hint').textContent = hintText;
        });

        // Build cart update payload — set every item in the bundle to the new qty
        const bundleItems = document.querySelectorAll(
            `[data-bundle-id="${bid}"]:not(.saka-set-multiplier)`
        );
        let updates = {};
        bundleItems.forEach(el => {
            const key = getLineKey(el);
            if (key) updates[key] = current;
        });

        updateCartAndReload(updates, row);
    });


    // =============================================
    // 5. Boot
    // =============================================
    initBundleMultipliers();

    // Re-inject after AJAX cart DOM mutations (e.g. theme re-renders the list)
    const cartList = document.querySelector('.previewCartList') || document.querySelector('.cart-list');
    if (cartList) {
        let debounce;
        new MutationObserver(() => {
            clearTimeout(debounce);
            debounce = setTimeout(initBundleMultipliers, 400);
        }).observe(cartList, { childList: true });
    }

});
